import { PlatformTypes } from "./platform-types";

export enum PlatformAccountStatus {
  Pending = "Pending",
  Ready = "Ready",
  Error = "Error"
}

export type ProvisioningStatusDto = "Pending" | "Ready" | "Error";

export type ProvisioningPlatform = keyof typeof PlatformTypes;

export interface ProvisioningTargetDto {
  platformId?: ProvisioningPlatform;
  widgetTypeSettingsId?: number;
}

export interface ProvisioningRetryPostDto extends ProvisioningTargetDto {
  accountId?: number;
}

export interface ProvisioningStatusGetDto {
  status: ProvisioningStatusDto;
  canRetry: boolean;
  canContactUs: boolean;
}

export interface ProvisioningRetryGetDto {
  status: PlatformAccountStatus;
}
